class ResetPasswordController {
  constructor() {
    this.name = 'resetPassword';
  }
}

export default ResetPasswordController;



// WEBPACK FOOTER //
// ./client/app/components/resetPassword/resetPassword.controller.js